import {useState} from "react";

export default function FormCheckbox({label, checked, onChange}) {
    let [id] = useState((Math.random() + 1).toString(36).substring(7));

    return (
        <div className="mt-4">
            <input
                id={id}
                className="mr-2 leading-tight "
                type="checkbox"
                onChange={(e) => onChange(e)}
                checked={checked}
            />
            <label
                htmlFor={id}
                className="select-none"
                dangerouslySetInnerHTML={{__html: label}}
            />
        </div>
    );
}
